import React from 'react';
import PropTypes from 'prop-types';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import BootstrapTooltip from 'react-bootstrap/Tooltip';

const Tooltip = (({ show, title, children, placement }) => {
  if (show) {
    return (
      <OverlayTrigger
        overlay={
          <BootstrapTooltip className={placement} id={`${title}-${new Date().getTime()}`}>
            {title}
          </BootstrapTooltip>
        }
        placement={placement}
        delayShow={300}
        delayHide={150}
      >
        {children}
      </OverlayTrigger>
    );
  }

  return children;
});

Tooltip.propTypes = {
  title: PropTypes.string.isRequired,
  placement: PropTypes.oneOf(['top', 'left', 'bottom', 'right']),
  children: PropTypes.node,
  show: PropTypes.bool
};

Tooltip.defaultProps = {
  title: '',
  placement: 'top',
  show: true
};

export default Tooltip;
